__turbopack_context__.v({
  "data": "styles-module-scss-module__py1Y8a__data",
  "footerActions": "styles-module-scss-module__py1Y8a__footerActions",
  "text": "styles-module-scss-module__py1Y8a__text",
  "top": "styles-module-scss-module__py1Y8a__top",
});
